import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

export function timeZones() {
  return {
    'Etc/GMT-12': 'GMT+12:00', // 实际是 UTC+12
    'Etc/GMT-11': 'GMT+11:00', // 实际是 UTC+11
    'Etc/GMT-10': 'GMT+10:00', // 实际是 UTC+10
    'Etc/GMT-9': 'GMT+09:00', // 实际是 UTC+9
    'Etc/GMT-8': 'GMT+08:00', // 实际是 UTC+8
    'Etc/GMT-7': 'GMT+07:00', // 实际是 UTC+7
    'Etc/GMT-6': 'GMT+06:00', // 实际是 UTC+6
    'Etc/GMT-5': 'GMT+05:00', // 实际是 UTC+5
    'Etc/GMT-4': 'GMT+04:00', // 实际是 UTC+4
    'Etc/GMT-3': 'GMT+03:00', // 实际是 UTC+3
    'Etc/GMT-2': 'GMT+02:00', // 实际是 UTC+2
    'Etc/GMT-1': 'GMT+01:00', // 实际是 UTC+1
    'Etc/GMT': 'GMT+00:00', // 实际是 UTC
    'Etc/GMT+1': 'GMT-01:00', // 实际是 UTC-1
    'Etc/GMT+2': 'GMT-02:00', // 实际是 UTC-2
    'Etc/GMT+3': 'GMT-03:00', // 实际是 UTC-3
    'Etc/GMT+4': 'GMT-04:00', // 实际是 UTC-4
    'Etc/GMT+5': 'GMT-05:00', // 实际是 UTC-5
    'Etc/GMT+6': 'GMT-06:00', // 实际是 UTC-6
    'Etc/GMT+7': 'GMT-07:00', // 实际是 UTC-7
    'Etc/GMT+8': 'GMT-08:00', // 实际是 UTC-8
    'Etc/GMT+9': 'GMT-09:00', // 实际是 UTC-9
    'Etc/GMT+10': 'GMT-10:00', // 实际是 UTC-10
    'Etc/GMT+11': 'GMT-11:00', // 实际是 UTC-11
    'Etc/GMT+12': 'GMT-12:00' // 实际是 UTC-12
  }
}
// 获取时区偏移量对应的时区
const getGMTOffsetTimeZone = (offsetInMinutes: number) => {
  const hours = Math.floor(Math.abs(offsetInMinutes) / 60)
  const sign = offsetInMinutes <= 0 ? '+' : '-'
  return `Etc/GMT${sign}${hours}`
}

//获取当前时区显示名称
export function currentLocalGMTZone() {
  const offsetInMinutes = new Date().getTimezoneOffset() // 本地时区与UTC的时
  const localGMTZone = getGMTOffsetTimeZone(-offsetInMinutes) //

  return localGMTZone
}

// 根据时区转换格式
export function convertToTimeZone(timestamp: number, timeZone: string) {
  const date = new Date(timestamp)

  const options: any = {
    timeZone: timeZone, // 使用传入的时区
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false // 24小时制
  }

  // 使用 'en-CA' 确保是 yyyy-MM-dd 格式的输出
  const formatter = new Intl.DateTimeFormat('en-CA', options)
  const formattedDate = formatter.format(date)

  return `${formattedDate.replace(',', '')}` // 输出格式：时区 + 日期
}

/*

输出格式; GMT+6: 2024-09-02 03:59:21

时区获取方式:
const currentStoreTimeZone = ref('')

watchEffect(async () => {
  currentStoreTimeZone.value = await useStoreStore().getCurrentStoreTimeZone()
})

*/
export function formatDate(timestamp: number, timeZone: string) {
  try {
    // const zones: any = timeZones()
    // const prefix = zones[timeZone]
    return `${convertToTimeZone(timestamp, timeZone)}`
  } catch (error) {
    return ''
  }
}

dayjs.extend(utc)
dayjs.extend(timezone)

// 获取当前商店时区，并将选择的时间转换为该时区的时间戳
export async function convertToStoreTimeZone(
  selectedTime: string | Date | null,
  timeZone: string
) {
  if (selectedTime === null) {
    return null
  }
  //时间格式,必须是YYYY-MM-DD HH:mm:ss
  const timeStamp = dayjs.tz(selectedTime, timeZone).valueOf()

  return timeStamp
}
